export const Yes = ({ className }) => (React.createElement("svg", { width: "18", height: "13", viewBox: "0 0 18 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className },
    React.createElement("path", { d: "M2 6.5 6 11l10.5-9", stroke: "#2789FF", "stroke-width": "3", "stroke-linecap": "round", "stroke-linejoin": "round" })));

